import { InvokeApi } from "../../Utils/InvokeApi";

export const CreateAnnouncement = async (data) => {
  const requestObj = {
    path: `/announcement/create`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};

export const UpdateAnnouncement = async (announcementId, data) => {
  const requestObj = {
    path: `/announcement/${announcementId}`,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};

export const GetAnnouncements = async (data) => {
  const { page, limit } = data;
  const params = new URLSearchParams();
  if (data !== false) {
    params.set('page', page.toString());
    params.set('limit', limit.toString());
  }
  let paramQuery = data !== false ? params.toString() : ""
  const requestObj = {
    path: `/announcement/get?${paramQuery}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const GetAnnouncementById = async (announcementId) => {
  const requestObj = {
    path: `/announcement/get/${announcementId}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const DeleteAnnouncement = async (announcementId) => {
  const requestObj = {
    path: `/announcement/${announcementId}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};
